import { createFileRoute } from '@tanstack/react-router'

import { PageContent } from '@/components/page-content'
import { PageHeaderSkeleton } from '@/components/skeleton/page-header-skeleton'
import { TableSkeleton } from '@/components/ui/table'
import { organizationsQueryOptions } from '@/modules/organization/presentation/hooks/useOrganizations'
import { OrganizationsPage } from '@/modules/organization/presentation/pages/Organizations'

export const Route = createFileRoute('/_authenticated/settings/')({
  component: OrganizationsPage,
  head: () => ({
    meta: [
      {
        title: 'Settings : Organizations',
      },
    ],
  }),
  loader: ({ context: { queryClient } }) => queryClient.ensureQueryData(organizationsQueryOptions),
  pendingComponent: () => (
    <>
      <PageHeaderSkeleton cta title="Organizations" />
      <PageContent>
        <TableSkeleton />
      </PageContent>
    </>
  ),
})
